<template>
    <article class="article-wrapper article4"
    :class="{'short-title':targetIdx !== 0, 'target3':targetIdx === 2}">
        <h1 class="title fade10" :class="{'active': $parent.isfadeInActive && $parent.isfadeInA4}"
        v-text="data.title">失物協尋：請同學返校協助找尋玉佩項鍊一只</h1>
        <div class="info-wrapper fade11"
        :class="{'active': $parent.isfadeInActive && $parent.isfadeInA4}">
            <p class="source">
                【發布單位／{{data.title_unit}}】
                <a href="" title="FB分享" class="fb-btn"
                @click.prevent="$parent.onShare('fb', data.share_link);
                gaEvent('share_fb', 'lost_sharefb');">
                    <img src="@/assets/images/btn_article_fb_n@3x.png" />
                </a>
                <a href="" title="Line分享" class="line-btn"
                @click.prevent="$parent.onShare('line', data.share_link_line, data.line_text);
                gaEvent('share_line', 'lost_shareline');">
                    <img src="@/assets/images/btn_article_line_n@3x.png" />
                </a>
            </p>
        </div>
        <div class="cols-wrapper fade12"
        :class="{'active': $parent.isfadeInActive && $parent.isfadeInA4}">
            <div class="photo-wrapper"
            :style="{'background-image':
            `url('${(data.images && data.images.length) ? data.images[0] : ''}')`}">
                <img id="article4Photo" :src="data.images[1]"
                class="photo" v-if="data.images && data.images.length && data.images[1]"/>
                <img src="@/assets/images/article4/img_article4_deer@2x.png"
                class="photo photo-placeholder" v-else/>
            </div>
            <p class="description" v-html="data.content">
                本處接獲同學遺失一貴重物品通知，此物為一小牛皮紙袋，
                內有一只白鹿玉珮和紙條，紙條上寫著：「白鹿是傳說的靈獸，據說會引導迷途的人，每當不安或迷惘，牠總能讓我覺得平靜一些。」
                請各位同學於7月6日至9月20日期間，務必持門票前往松菸文創園區協助找尋，本處將給予尋獲者神秘的獎勵。
            </p>
        </div>
    </article>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'report4',
    props: {
        data: {
            type: Object,
            default() {
                return {
                    title: '',
                    title_unit: '',
                    content: '',
                    images: [],
                    share_link: '',
                };
            },
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            gaCategory: '',
        };
    },
    mounted() {
    },
    methods: {
    },
    watch: {
    },
    mixins: [mixinMethod],
};
</script>
